import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';

const resultsList1 = {
    colorNumber: '#90134e',
    list: [
        'Помочь взять кредит на&nbsp;бизнес',
        'Найти спонсора для запуска стартапа',
        'Разобраться с&nbsp;проблемами резидентов',
        'Получить заявку на&nbsp;технические условия',
    ],
};

const resultsList2 = {
    colorNumber: '#90134e',
    list: ['Автоматизация', 'Обмен данными с&nbsp;внешними системами'],
};

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="krdv-results">
                <div className="krdv-results__wrapper">
                    <div className="krdv-results__info">
                        <CommonTitle>Результаты</CommonTitle>
                        <CommonUsualText className="krdv-results__usual-text">
                            {parse(
                                'В&nbsp;итоге за&nbsp;6&nbsp;месяцев разработали 7&nbsp;сервисов, которые сделают проще жизнь многих пользователей, чтобы:'
                            )}
                        </CommonUsualText>
                        <div className="krdv-results__first-list-container">
                            <CommonOlList CommonOlList={resultsList1} />
                        </div>
                        <CommonUsualText className="krdv-results__usual-text">
                            Каждый сервис является стартовой площадкой, которая имеет огромный
                            потенциал развития:
                        </CommonUsualText>
                        <CommonOlList CommonOlList={resultsList2} />
                    </div>
                    <div className="krdv-results__img">
                        <img src="/images/svg/krdv/krdv-results__img.svg" alt="" loading="lazy" />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
